import script from "./PermissionsWrapper.vue?vue&type=script&setup=true&lang=ts"
export * from "./PermissionsWrapper.vue?vue&type=script&setup=true&lang=ts"

import "./PermissionsWrapper.vue?vue&type=style&index=0&id=b239c498&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b239c498"]])

export default __exports__